import TableToolbar from "componentsv2/table/TableToolbar";
import TableTitle from "componentsv2/table/TableTitle";
import TableState from "componentsv2/table/TableState";

function TableHeader({
  layout,
  handleView,
  handleReturn,
  Toolbar,
  storeId,
  kind,
  count,
  reloadIdSignal,
  reload,
  showBackButton,
  returnFilter,
  setView,
  showStates = true,
}) {
  return (
    <div id="table-header">
      <div className="flex max-md:flex-col max-md:items-start h-full py-1 my-3 gap-y-3">
        <TableTitle
          layout={layout}
          kind={kind}
          showBackButton={showBackButton}
          handleReturn={handleReturn}
        />
        {Toolbar && <div className="flex text-neutral-500">{Toolbar}</div>}
        <TableToolbar
          actions={layout.table_action}
          layout={layout}
          handleView={handleView}
          storeId={storeId}
          kind={kind}
          count={count}
          reloadIdSignal={reloadIdSignal}
          reload={reload}
          returnFilter={returnFilter}
          setView={setView}
        />
      </div>
      {showStates && (
        <div>
          {layout?.tableStateComponent ? (
            <layout.tableStateComponent
              states={layout?.tags?.state}
              model={layout?.model}
              storeId={storeId}
              layout={layout}
            />
          ) : (
              <TableState
              states={layout?.tags?.state}
              model={layout?.model}
              storeId={storeId}
              layout={layout}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default TableHeader;
